import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { baseURL } from 'src/config/api/routes';
import { RootState } from '../store';

export const prepareHeaders = (
  headers: Headers,
  api: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>
) => {
  const { jwt, sessionId } = (api.getState() as RootState).auth;

  headers.set('Content-Type', 'application/json');
  headers.set('authorization', `Bearer ${jwt}`);
  headers.set('Session-Id', sessionId ?? '');
  headers.set('App-Url', window.location.href);

  return headers;
};

export const appBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders,
  });
  const result = await baseQuery(args, api, extraOptions);

  return result;
};
